import { useCallback, useEffect, useState } from 'react';
import { Button, Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import { PromotionalBalanceService } from '../../services/PromotionalBalanceService';
import { formatDateTime } from '../../utils/DateTimeUtils';

const promotionalBalanceService = new PromotionalBalanceService();

const COLUMNS: CommonListColumn[] = [
    { label: 'Id', field: 'id' },
    { label: 'Amount', field: 'amount' },
    { label: 'Wallet Id', field: 'walletId' },
    { label: 'Status', field: 'status', type: 'status' },
    { label: 'Payment Status', field: 'paymentStatus', type: 'status' },
    {
        label: 'Added By',
        render: (row) => {
            const id = row?.createdBy;
            const type = row?.createdByType;
            if (!id) return '-';
            if (type === 'ADMIN') return <Link href={`/#/AdminUsers/${id}/show`}>{id}</Link>;
            if (type === 'CUSTOMER') return <Link href={`/#/Customers/${id}/show`}>{id}</Link>;
            return id;
        },
    },
    { label: 'Added By Type', field: 'createdByType' },
    {
        label: 'Notes',
        render: (row) => row?.notes || '-',
    },
    {
        label: 'Expires At',
        render: (row) => (row?.expiresAt ? formatDateTime(row.expiresAt) : '-'),
    },
    {
        label: 'Action',
        stopRowClick: true,
        render: (row) => (
            <Link href={`/#/PromotionalBalance/${row?.id}/show`}>
                <Button variant="contained" color="primary" size="small">Show</Button>
            </Link>
        ),
    },
];

function CustomerPromotionalBalanceList(props: any) {
    const { walletId } = props;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState<any[]>([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const refreshData = useCallback(() => {
        setLoading(true);
        promotionalBalanceService
            .getAllPromotionalBalanceForUser(walletId, rowsPerPage, rowsPerPage * page, {
                order: 'DESC',
                field: 'createdAt',
            })
            .then((res: any) => {
                setData(res?.data ?? []);
                setTotal(res?.count ?? 0);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [walletId, page, rowsPerPage]);

    useEffect(() => {
        refreshData();
    }, [refreshData]);

    return (
        <CommonListTable
            columns={COLUMNS}
            data={data}
            loading={loading}
            page={page}
            rowsPerPage={rowsPerPage}
            total={total}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyText="No promotional balances found"
        />
    );
}

export default CustomerPromotionalBalanceList;
